import { IncrementalSearchResponse, IncrementalSearchResponseDataType, useIncrementalSearchV2LazyQuery } from 'generated/graphql'
import { debounce } from 'lib/debounce'
import { useCallback, useMemo, useRef, useState } from 'react'

const defaultTypes: IncrementalSearchResponseDataType[] = []

export const useIncrementalSearchV2 = ({
  limit,
  delayMilliseconds,
  types = defaultTypes,
}: {
  limit: number
  delayMilliseconds: number
  types?: IncrementalSearchResponseDataType[]
}) => {
  const keywordRef = useRef<string>('')
  const [searchResult, setSearchResult] = useState<IncrementalSearchResponse>()
  const [fetch, { error, variables, loading: searching }] = useIncrementalSearchV2LazyQuery({
    onCompleted: data => {
      setSearchResult(keywordRef.current.trim().length === 0 ? { data: [] } : data?.incrementalSearchV2)
    },
  })

  const searchDebounce = useMemo(
    () =>
      debounce(async (keyword: string) => {
        fetch({ variables: { input: { keyword, limit, types } } })
      }, delayMilliseconds),
    [limit, types]
  )

  const search = useCallback(
    (keyword: string) => {
      keywordRef.current = keyword

      if (keyword.trim().length === 0) {
        setSearchResult({ data: [] })
        return
      }

      if (keyword === variables?.input?.keyword) return

      setSearchResult({ data: [] })
      searchDebounce(keyword)
    },
    [searchDebounce, variables?.input?.keyword]
  )

  return { search, searchResult, loading: searching, error }
}
